import PropTypes from 'prop-types';
import qs from 'query-string';
import { Component } from 'react';
import { connect } from 'react-redux';

import { PrimeError } from '../../../../common/types';
import { RenderPropWithProps, RouteProps, TranslationFuncProp } from '../../../../common/types/prop-types/common';
import { Utils } from '../../../../common/utils';
import { RootState } from '../../../base/RootReducer';
import { config } from '../../../common/';

export interface SignInLayoutProps {
}

export interface SignInLayoutContainerProps {
}

interface ReduxStateProps {
    isAuthenticated: boolean | null;
}

interface ReduxDispatchProps {
}

class SignInLayoutContainer extends Component<
    SignInLayoutContainerProps &
    TranslationFuncProp &
    RouteProps &
    RenderPropWithProps<SignInLayoutProps> &
    ReduxStateProps &
    ReduxDispatchProps
> {
    public static propTypes = {
        t: PropTypes.func.isRequired,
        routeProps: PropTypes.any.isRequired,
        isAuthenticated: PropTypes.bool,
        location: PropTypes.object,
        //
        children: PropTypes.func.isRequired,
    };

    public componentDidMount() {
        const parsed = qs.parse(this.props.routeProps.location.search);
        const parsedRedirect: string = Array.isArray(parsed.redirect) ? (parsed.redirect[0] || `${config.BaseURL}`) : (parsed.redirect || `${config.BaseURL}`);

        if (this.props.isAuthenticated) {
            this.props.routeProps.history.push(parsedRedirect);
        } else {
            try {
                // generate state (JWT) for GCDM

                // check for parameters
                const { redirect, ...params } = parsed;
                const handleRedirect = async () => {
                    try {
                        const stateToken = params && Object.keys(params).length > 0
                            ? await Utils.generateJwtStateWithParams(parsedRedirect, params)
                            : await Utils.generateJwtState(parsedRedirect);
                        window.top!.location.href = config.ExternalAuthURL + `&state=${stateToken}`;
                    } catch (ex) {
                        throw new PrimeError(this.props.t(`errorMessages.redirectBlock.errorHeader`), this.props.t(`errorMessages.redirectBlock.errorDescription`).replace('{0}', config.BaseURL), false);
                    }
                };
                handleRedirect();
            } catch (ex) {
                throw new PrimeError(this.props.t(`errorMessages.redirectBlock.errorHeader`), this.props.t(`errorMessages.redirectBlock.errorDescription`).replace('{0}', config.BaseURL), false);
            }
            return;
        }
    }

    public render() {
        return this.props.children({});
    }
}

const mapStateToProps = (store: RootState) => ({
    isAuthenticated: store.authState.isAuthenticated,
});

export default connect(mapStateToProps)(SignInLayoutContainer);
